import { render, staticRenderFns } from "./schoolUserInfo.vue?vue&type=template&id=1516ba70"
import script from "./schoolUserInfo.vue?vue&type=script&lang=js"
export * from "./schoolUserInfo.vue?vue&type=script&lang=js"
import style0 from "./schoolUserInfo.vue?vue&type=style&index=0&id=1516ba70&prod&lang=less&scope=true"
import style1 from "./schoolUserInfo.vue?vue&type=style&index=1&id=1516ba70&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports